var $class="se2--application-social-media-share-horizontal",$name="ApplicationSocialMediaShareHorizontal",$path="app/components/ApplicationSocialMediaShareHorizontal/index.js",$this={$class,$name,$path,};import shell from 'app/modules/shell';

import forEach from 'lodash/forEach';
import esapi from 'node-esapi';
import analytics from 'app/modules/analytics';
import { placeholderInUrl, socialLinkSelector, printButtonSelector } from './config';

export default shell.registerComponent($this, ({ mount }) => {
  mount((element) => {
    const { origin, pathname, search } = window.location;
    let currentURL = origin + pathname;

    if (search) currentURL += esapi.encoder().encodeForURL(search);

    forEach(
      element.querySelectorAll(printButtonSelector),
      (printButton) => {
        printButton?.addEventListener('click', () => {
          window.print();
          if (pathname.includes('/insights/')) {
            analytics.onCTAClick(true, printButton);
          } else {
            analytics.onCTAClick(false, printButton);
          }
        });
      },
    );

    forEach(
      element.querySelectorAll(socialLinkSelector),
      (link) => {
        link.href = link.href.replace(placeholderInUrl, currentURL);
        link?.addEventListener('click', () => {
          if (pathname.includes('/insights/')) {
            analytics.onCTAClick(true, link);
          } else {
            analytics.onCTAClick(false, link);
          }
        });
      },
    );
  });
});
